/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralContractSearchItem } from './nonCadastralContractSearchItem.model';


export interface ListResponseNonCadastralContractSearchItem { 
    itemCount?: number;
    items?: Array<NonCadastralContractSearchItem>;
    params?: { [key: string]: any; };
}

